import { useInfiniteQuery } from '@tanstack/react-query';
import type { MiceOrderEventView } from '@voll-intelligence/domain';
import { queryKeys } from '@web/core/query';
import { miceRepository } from '@web/data/repositories';
import { useOrgContext } from '@web/ui/core';
import { fireAndForget } from '@web/ui/core/utils';
import { REFETCH_MS } from './use_mice_orders';

/** Feed da compra por cursor; `live` refaz as páginas lidas no mesmo ritmo do projeto. */
export function useMiceActivity(
  projectId: string,
  live: boolean,
): {
  events: MiceOrderEventView[];
  isError: boolean;
  hasMore: boolean;
  loadMore: () => void;
} {
  const { orgId } = useOrgContext();
  const query = useInfiniteQuery({
    queryKey: queryKeys.mice.activity(orgId, projectId),
    queryFn: ({ pageParam }) => miceRepository.listActivity(orgId, projectId, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextBefore ?? undefined,
    refetchInterval: live ? REFETCH_MS : false,
    refetchIntervalInBackground: false,
  });
  return {
    events: query.data?.pages.flatMap((p) => p.items) ?? [],
    isError: query.isError,
    hasMore: query.hasNextPage,
    loadMore: () => {
      fireAndForget(query.fetchNextPage());
    },
  };
}
